const translations = {
  es: {
    title: "Gestión de Servicios",
    newService: "Nuevo Servicio",
    loading: "Cargando servicios...",
    capacity: "Capacidad",
    category: "Categoría",
    price: "Precio",
    status: "Estado",
    active: "Activo",
    inactive: "Inactivo",
    edit: "Editar",
    deactivate: "Desactivar",
    activate: "Activar",
    cancel: "Cancelar",
    operationSuccess: "✅ Operación exitosa",
    operatorNotFound: "No se encontró el ID del operador.",
    errorOperation: "Error en la operación",
    errorFetchServices: "Error al obtener servicios",
    delete: "Eliminar",
    confirmDelete: "¿Estás seguro de que deseas eliminar este servicio?",
    deleteSuccess: "Servicio eliminado correctamente",
    deleteError: "Error al eliminar el servicio",
    cannotDeleteDueToReservations: "No se puede eliminar el servicio porque tiene reservaciones asociadas no expiradas",
    cannotUpdateDueToReservations: "No se puede editar el servicio debido a que tiene reservaciones activas",
    cannotUpdateongoingprocess: "No se puede editar el servicio debido a que tiene una transaccion en curso",
    cannotDeleteongoingprocess: "No se puede eliminar el servicio debido que hay una transacción en curso",
    noImage:"Sin imagen"
  },
  en: {
    title: "Service Management",
    newService: "New Service",
    loading: "Loading services...",
    capacity: "Capacity",
    category: "Category",
    price: "Price",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    edit: "Edit",
    deactivate: "Deactivate",
    activate: "Activate",
    cancel: "Cancel",
    operationSuccess: "✅ Operation successful",
    operatorNotFound: "Operator ID not found.",
    errorOperation: "Operation error",
    errorFetchServices: "Error fetching services",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete this service?",
    deleteSuccess: "Service deleted successfully",
    deleteError: "Error deleting service",
    cannotDeleteDueToReservations: "Cannot delete service because it has associated reservations not expired",
    cannotUpdateDueToReservations: "Cannot edit service due to active reservations",
    cannotDeleteongoingprocess:"The service cannot be deleted because a transaction is in progress",
    cannotUpdateongoingprocess:"The service cannot be updated because a transaction is in progress",
    noImage:"No image"

    


  }
};

export default translations